import React from 'react';
import FederatedResult from './results/result';

class NafsaFederatedResult extends FederatedResult {
  render() {
    const { doc, highlight } = this.props;

    let resultType;
    if (doc.ss_federated_type) {
      resultType = doc.ss_federated_type;
      if (doc.ss_federated_date) {
        resultType += ' | ';
      }
    }

    let resultDate = false;
    if (doc.ss_federated_date) {
      resultDate = new Date(doc.ss_federated_date);
      const dateOptions = { year: 'numeric', month: 'long', day: 'numeric' };
      resultDate = resultDate.toLocaleDateString('en-US', dateOptions);
    }

    let resultBody;
    if (highlight.tm_X3b_en_rendered_item) {
      resultBody = highlight.tm_X3b_en_rendered_item;
    } else if (doc.zs_federated_summary) {
      resultBody = doc.zs_federated_summary;
    }

    return (
      <li className="clearfix" onClick={() => this.props.onSelect(doc)}>
        {doc.ss_federated_image &&
        <div className="image">
          <a href={this.getCanonicalLink(doc)}>
            <img src={doc.ss_federated_image} alt=""/>
          </a>
        </div>
        }
        <div className={doc.ss_federated_image ? 'content' : 'content full'}>
          {resultType &&
          <div className="search-results__type">{resultType}</div>
          }
          {resultDate &&
          <div className="search-results__date">{resultDate}</div>
          }

          <span className="search-results__type-2">{doc.ss_federated_product_type}</span>

          <h3 className="search-results__title"><a href={this.getCanonicalLink(doc)}>{doc.tcedgestringm_X3b_en_federated_title}</a></h3>

          {resultBody &&
          <div className="search-results__body"><p dangerouslySetInnerHTML={{ __html: resultBody }}/></div>
          }
        </div>
      </li>
    );
  }
}

export default NafsaFederatedResult;



// WEBPACK FOOTER //
// ./src/components/NafsaComponents.js